// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-list-item {
  align-items: center;
  display: grid;
  flex: none;
  grid-template-areas: "prepend content append";
  grid-template-columns: max-content 1fr auto;
  outline: none;
  max-width: 100%;
  padding: 4px 16px;
  position: relative;
  text-decoration: none;
}
:where(.vuetify-styles) .v-list-item {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-list-item--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-list-item:hover > .v-list-item__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-list-item:focus-visible > .v-list-item__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-list-item:focus > .v-list-item__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-list-item--active > .v-list-item__overlay, :where(.vuetify-styles) .v-list-item[aria-haspopup=menu][aria-expanded=true] > .v-list-item__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-list-item--active:hover > .v-list-item__overlay, :where(.vuetify-styles) .v-list-item[aria-haspopup=menu][aria-expanded=true]:hover > .v-list-item__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-list-item--active:focus-visible > .v-list-item__overlay, :where(.vuetify-styles) .v-list-item[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-list-item__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-list-item--active:focus > .v-list-item__overlay, :where(.vuetify-styles) .v-list-item[aria-haspopup=menu][aria-expanded=true]:focus > .v-list-item__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-list-item {
  border-radius: 0;
}
:where(.vuetify-styles) .v-list-item--variant-plain, :where(.vuetify-styles) .v-list-item--variant-outlined, :where(.vuetify-styles) .v-list-item--variant-text, :where(.vuetify-styles) .v-list-item--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-list-item--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-list-item--variant-plain:focus, :where(.vuetify-styles) .v-list-item--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-list-item--variant-plain .v-list-item__overlay {
  display: none;
}
:where(.vuetify-styles) .v-list-item--variant-elevated, :where(.vuetify-styles) .v-list-item--variant-flat {
  background: rgba(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-list-item--variant-elevated {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-list-item--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-list-item--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-list-item--variant-text .v-list-item__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-list-item--variant-tonal .v-list-item__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-list-item .v-list-item__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-list-item--focus-visible .v-list-item__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports selector(:focus-visible) {
  :where(.vuetify-styles) .v-list-item::after {
    pointer-events: none;
    border: 2px solid currentColor;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  :where(.vuetify-styles) .v-list-item::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  :where(.vuetify-styles) .v-list-item:focus-visible::after, :where(.vuetify-styles) .v-list-item--focus-visible::after {
    opacity: calc(0.15 * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-list-item__prepend > .v-badge .v-icon,
:where(.vuetify-styles) .v-list-item__prepend > .v-icon,
:where(.vuetify-styles) .v-list-item__append > .v-badge .v-icon,
:where(.vuetify-styles) .v-list-item__append > .v-icon {
  opacity: var(--v-medium-emphasis-opacity);
}
:where(.vuetify-styles) .v-list-item--active .v-list-item__prepend > .v-badge .v-icon,
:where(.vuetify-styles) .v-list-item--active .v-list-item__prepend > .v-icon,
:where(.vuetify-styles) .v-list-item--active .v-list-item__append > .v-badge .v-icon,
:where(.vuetify-styles) .v-list-item--active .v-list-item__append > .v-icon {
  opacity: 1;
}
:where(.vuetify-styles) .v-list-item--active:not(.v-list-item--link) .v-list-item__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-list-item--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-list-item--disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.6;
}
:where(.vuetify-styles) .v-list-item--link {
  cursor: pointer;
}
:where(.vuetify-styles) .v-navigation-drawer--rail:not(.v-navigation-drawer--expand-on-hover) .v-list-item .v-avatar, :where(.vuetify-styles) .v-navigation-drawer--rail.v-navigation-drawer--expand-on-hover:not(.v-navigation-drawer--is-hovering) .v-list-item .v-avatar {
  --v-avatar-height: 24px;
}

:where(.vuetify-styles) .v-list-item__prepend {
  align-items: center;
  align-self: center;
  display: flex;
  grid-area: prepend;
}
:where(.vuetify-styles) .v-list-item__prepend * ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap);
}
:where(.vuetify-styles) .v-list-item__prepend > .v-badge ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__prepend > .v-icon ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 32px);
}
:where(.vuetify-styles) .v-list-item__prepend > .v-avatar ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__prepend > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 16px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-badge ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-icon ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 20px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-avatar ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 4px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__prepend > .v-list-item-action ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 4px);
}
:where(.vuetify-styles) .v-list-item--three-line .v-list-item__prepend {
  align-self: start;
}

:where(.vuetify-styles) .v-list-item__append {
  align-self: center;
  display: flex;
  align-items: center;
  grid-area: append;
}
:where(.vuetify-styles) .v-list-item__append .v-list-item__spacer {
  order: -1;
  transition: 150ms width cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-list-item__append * ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap);
}
:where(.vuetify-styles) .v-list-item__append > .v-badge ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__append > .v-icon ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__append > .v-tooltip ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 32px);
}
:where(.vuetify-styles) .v-list-item__append > .v-avatar ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item__append > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 16px);
}
:where(.vuetify-styles) .v-list-item__append > .v-list-item-action ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 16px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-badge ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-icon ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-tooltip ~ .v-list-item__spacer {
  width: var(--v-list-slim-spacer-width, 20px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-avatar ~ .v-list-item__spacer,
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 4px);
}
:where(.vuetify-styles) .v-list-item--slim .v-list-item__append > .v-list-item-action ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 4px);
}
:where(.vuetify-styles) .v-list-item--three-line .v-list-item__append {
  align-self: start;
}

:where(.vuetify-styles) .v-list-item__content {
  align-self: center;
  grid-area: content;
  overflow: hidden;
  min-width: 40px;
}
:where(.vuetify-styles) .v-navigation-drawer--rail:not(.v-navigation-drawer--expand-on-hover) .v-list-item__content, :where(.vuetify-styles) .v-navigation-drawer--rail.v-navigation-drawer--expand-on-hover:not(.v-navigation-drawer--is-hovering) .v-list-item__content {
  min-width: 0;
}

:where(.vuetify-styles) .v-list-item-action {
  align-self: center;
  display: flex;
  align-items: center;
  flex: none;
  transition: inherit;
  transition-property: height, width;
}
:where(.vuetify-styles) .v-list-item-action--start {
  margin-inline-end: 8px;
  margin-inline-start: -8px;
}
:where(.vuetify-styles) .v-list-item-action--end {
  margin-inline-start: 8px;
  margin-inline-end: -8px;
}

:where(.vuetify-styles) .v-list-item-media {
  margin-top: 0;
  margin-bottom: 0;
}
:where(.vuetify-styles) .v-list-item-media--start {
  margin-inline-end: 16px;
}
:where(.vuetify-styles) .v-list-item-media--end {
  margin-inline-start: 16px;
}
:where(.vuetify-styles) .v-list-item--two-line .v-list-item-media {
  margin-top: -4px;
  margin-bottom: -4px;
}
:where(.vuetify-styles) .v-list-item--three-line .v-list-item-media {
  margin-top: 0;
  margin-bottom: 0;
}

:where(.vuetify-styles) .v-list-item-subtitle {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  opacity: var(--v-list-item-subtitle-opacity, var(--v-medium-emphasis-opacity));
  overflow: hidden;
  padding: 0;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  word-break: initial;
}
:where(.vuetify-styles) .v-list-item--one-line .v-list-item-subtitle {
  -webkit-line-clamp: 1;
}
:where(.vuetify-styles) .v-list-item--two-line .v-list-item-subtitle {
  -webkit-line-clamp: 2;
}
:where(.vuetify-styles) .v-list-item--three-line .v-list-item-subtitle {
  -webkit-line-clamp: 3;
}
:where(.vuetify-styles) .v-list-item-subtitle {
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1rem;
  text-transform: none;
}
:where(.vuetify-styles) .v-list-item--nav .v-list-item-subtitle {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1rem;
}

:where(.vuetify-styles) .v-list-item-title {
  hyphens: auto;
  overflow-wrap: normal;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: normal;
  word-wrap: break-word;
}
:where(.vuetify-styles) .v-list-item-title {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.009375em;
  line-height: 1.5;
  text-transform: none;
}
:where(.vuetify-styles) .v-list-item--nav .v-list-item-title {
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 1rem;
}

:where(.vuetify-styles) .v-list-item--density-default {
  min-height: 40px;
}
:where(.vuetify-styles) .v-list-item--density-default.v-list-item--one-line {
  min-height: 48px;
  padding-top: 4px;
  padding-bottom: 4px;
}
:where(.vuetify-styles) .v-list-item--density-default.v-list-item--two-line {
  min-height: 64px;
  padding-top: 12px;
  padding-bottom: 12px;
}
:where(.vuetify-styles) .v-list-item--density-default.v-list-item--three-line {
  min-height: 88px;
  padding-top: 16px;
  padding-bottom: 16px;
}
:where(.vuetify-styles) .v-list-item--density-default.v-list-item--three-line .v-list-item__prepend,
:where(.vuetify-styles) .v-list-item--density-default.v-list-item--three-line .v-list-item__append {
  padding-top: 8px;
}
:where(.vuetify-styles) .v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-default:not(.v-list-item--nav).v-list-item--two-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-default:not(.v-list-item--nav).v-list-item--three-line {
  padding-inline: 16px;
}

:where(.vuetify-styles) .v-list-item--density-comfortable {
  min-height: 36px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable.v-list-item--one-line {
  min-height: 44px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable.v-list-item--two-line {
  min-height: 60px;
  padding-top: 8px;
  padding-bottom: 8px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable.v-list-item--three-line {
  min-height: 84px;
  padding-top: 12px;
  padding-bottom: 12px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable.v-list-item--three-line .v-list-item__prepend,
:where(.vuetify-styles) .v-list-item--density-comfortable.v-list-item--three-line .v-list-item__append {
  padding-top: 6px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--two-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--three-line {
  padding-inline: 16px;
}

:where(.vuetify-styles) .v-list-item--density-compact {
  min-height: 32px;
}
:where(.vuetify-styles) .v-list-item--density-compact.v-list-item--one-line {
  min-height: 40px;
}
:where(.vuetify-styles) .v-list-item--density-compact.v-list-item--two-line {
  min-height: 56px;
  padding-top: 4px;
  padding-bottom: 4px;
}
:where(.vuetify-styles) .v-list-item--density-compact.v-list-item--three-line {
  min-height: 80px;
  padding-top: 8px;
  padding-bottom: 8px;
}
:where(.vuetify-styles) .v-list-item--density-compact.v-list-item--three-line .v-list-item__prepend,
:where(.vuetify-styles) .v-list-item--density-compact.v-list-item--three-line .v-list-item__append {
  padding-top: 4px;
}
:where(.vuetify-styles) .v-list-item--density-compact:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-compact:not(.v-list-item--nav).v-list-item--two-line {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-list-item--density-compact:not(.v-list-item--nav).v-list-item--three-line {
  padding-inline: 16px;
}

:where(.vuetify-styles) .v-list-item--nav {
  padding-inline: 8px;
}

:where(.vuetify-styles) .v-list-item__underlay {
  position: absolute;
}

:where(.vuetify-styles) .v-list-item__overlay {
  background-color: currentColor;
  border-radius: inherit;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.2s ease-in-out;
  transition-property: opacity, color;
}
:where(.vuetify-styles) .v-list-item--active.v-list-item--variant-elevated .v-list-item__overlay {
  --v-theme-overlay-multiplier: 0;
}

:where(.vuetify-styles) .v-list {
  --indent-padding: 0px;
}
:where(.vuetify-styles) .v-list--nav {
  --indent-padding: -8px;
}

:where(.vuetify-styles) .v-list-group {
  --list-indent-size: 16px;
  --parent-padding: var(--indent-padding);
  --prepend-width: var(--v-list-group-prepend, 40px);
}
:where(.vuetify-styles) .v-list--slim .v-list-group {
  --prepend-width: var(--v-list-group-prepend, 28px);
}
:where(.vuetify-styles) .v-list-group--fluid {
  --list-indent-size: 0px;
}
:where(.vuetify-styles) .v-list-group--prepend {
  --parent-padding: calc(var(--indent-padding) + var(--prepend-width));
}
:where(.vuetify-styles) .v-list-group--fluid.v-list-group--prepend {
  --parent-padding: var(--indent-padding);
}

:where(.vuetify-styles) .v-list-group__items {
  --indent-padding: calc(var(--parent-padding) + var(--v-list-indent, var(--list-indent-size)));
  min-width: min-content;
}
:where(.vuetify-styles) .v-navigation-drawer--rail .v-list-group__items {
  min-width: 0;
}

:where(.vuetify-styles) .v-list-group__items .v-list-item {
  padding-inline-start: calc(16px + var(--indent-padding)) !important;
}

:where(.vuetify-styles) .v-list-group__header:not(.v-treeview-item--activatable-group-activator).v-list-item--active:not(:focus-visible) .v-list-item__overlay {
  opacity: 0;
}
:where(.vuetify-styles) .v-list-group__header:not(.v-treeview-item--activatable-group-activator).v-list-item--active:hover .v-list-item__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-list-item--link:not(.v-list-item--active) {
    color: buttontext;
  }
  :where(.vuetify-styles) .v-list-item--link[href]:not(.v-list-item--active) {
    color: unset;
  }
  :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--disabled) [class*=v-list-item-],
  :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--disabled) [class*=v-list-item-] > *,
  :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--disabled) .v-icon {
    color: highlight !important;
  }
  :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) {
    background: highlight !important;
  }
  :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) [class*=v-list-item-], :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) [class*=v-list-item-] > *, :where(.vuetify-styles) .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) .v-icon {
    opacity: 1;
    color: highlighttext !important;
    forced-color-adjust: preserve-parent-color;
  }
  :where(.vuetify-styles) .v-list-item--focus-visible::after {
    opacity: 1;
  }
  @supports selector(:focus-visible) {
    :where(.vuetify-styles) .v-list-item::after {
      color: buttontext;
    }
    :where(.vuetify-styles) .v-list-item:focus-visible::after {
      opacity: 1;
    }
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VList/VListItem.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,6CAA6C;EAC7C,2CAA2C;EAC3C,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,sEAAsE;AACxE;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;EACA;IACE,uDAAuD;EACzD;AACF;AACA;;;;EAGE,yCAAyC;AAC3C;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,sCAAsC;AACxC;AACA;;EAEE,sCAAsC;AACxC;AACA;;;EAGE,sCAAsC;AACxC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,oDAAoD;AACtD;AACA;EACE,gCAAgC;AAClC;AACA;;;EAGE,sCAAsC;AACxC;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;;;EAGE,4CAA4C;AAC9C;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,8EAA8E;EAC9E,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oEAAoE;AACtE;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,6FAA6F;EAC7F,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,UAAU;AACZ;AACA;EACE,yEAAyE;AAC3E;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;;IAGE,2BAA2B;EAC7B;EACA;IACE,gCAAgC;EAClC;EACA;IAGE,UAAU;IACV,+BAA+B;IAC/B,0CAA0C;EAC5C;EACA;IACE,UAAU;EACZ;EACA;IACE;MACE,iBAAiB;IACnB;IACA;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":[".v-list-item {\n  align-items: center;\n  display: grid;\n  flex: none;\n  grid-template-areas: \"prepend content append\";\n  grid-template-columns: max-content 1fr auto;\n  outline: none;\n  max-width: 100%;\n  padding: 4px 16px;\n  position: relative;\n  text-decoration: none;\n}\n.v-list-item {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-list-item--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-list-item:hover > .v-list-item__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-list-item:focus-visible > .v-list-item__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-list-item:focus > .v-list-item__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-list-item--active > .v-list-item__overlay, .v-list-item[aria-haspopup=menu][aria-expanded=true] > .v-list-item__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-list-item--active:hover > .v-list-item__overlay, .v-list-item[aria-haspopup=menu][aria-expanded=true]:hover > .v-list-item__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-list-item--active:focus-visible > .v-list-item__overlay, .v-list-item[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-list-item__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-list-item--active:focus > .v-list-item__overlay, .v-list-item[aria-haspopup=menu][aria-expanded=true]:focus > .v-list-item__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-list-item {\n  border-radius: 0;\n}\n.v-list-item--variant-plain, .v-list-item--variant-outlined, .v-list-item--variant-text, .v-list-item--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-list-item--variant-plain {\n  opacity: 0.62;\n}\n.v-list-item--variant-plain:focus, .v-list-item--variant-plain:hover {\n  opacity: 1;\n}\n.v-list-item--variant-plain .v-list-item__overlay {\n  display: none;\n}\n.v-list-item--variant-elevated, .v-list-item--variant-flat {\n  background: rgba(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-list-item--variant-elevated {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-list-item--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-list-item--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-list-item--variant-text .v-list-item__overlay {\n  background: currentColor;\n}\n.v-list-item--variant-tonal .v-list-item__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-list-item .v-list-item__underlay {\n  position: absolute;\n}\n.v-list-item--focus-visible .v-list-item__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports selector(:focus-visible) {\n  .v-list-item::after {\n    pointer-events: none;\n    border: 2px solid currentColor;\n    border-radius: 4px;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n  }\n  .v-list-item::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  .v-list-item:focus-visible::after, .v-list-item--focus-visible::after {\n    opacity: calc(0.15 * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-list-item__prepend > .v-badge .v-icon,\n.v-list-item__prepend > .v-icon, .v-list-item__append > .v-badge .v-icon,\n.v-list-item__append > .v-icon {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-list-item--active .v-list-item__prepend > .v-badge .v-icon,\n.v-list-item--active .v-list-item__prepend > .v-icon,\n.v-list-item--active .v-list-item__append > .v-badge .v-icon,\n.v-list-item--active .v-list-item__append > .v-icon {\n  opacity: 1;\n}\n.v-list-item--active:not(.v-list-item--link) .v-list-item__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-list-item--rounded {\n  border-radius: 4px;\n}\n.v-list-item--disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.6;\n}\n.v-list-item--link {\n  cursor: pointer;\n}\n.v-navigation-drawer--rail:not(.v-navigation-drawer--expand-on-hover) .v-list-item .v-avatar, .v-navigation-drawer--rail.v-navigation-drawer--expand-on-hover:not(.v-navigation-drawer--is-hovering) .v-list-item .v-avatar {\n  --v-avatar-height: 24px;\n}\n\n.v-list-item__prepend {\n  align-items: center;\n  align-self: center;\n  display: flex;\n  grid-area: prepend;\n}\n.v-list-item__prepend * ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap);\n}\n.v-list-item__prepend > .v-badge ~ .v-list-item__spacer,\n.v-list-item__prepend > .v-icon ~ .v-list-item__spacer,\n.v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 32px);\n}\n.v-list-item__prepend > .v-avatar ~ .v-list-item__spacer,\n.v-list-item__prepend > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 16px);\n}\n.v-list-item--slim .v-list-item__prepend > .v-badge ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__prepend > .v-icon ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 20px);\n}\n.v-list-item--slim .v-list-item__prepend > .v-avatar ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__prepend > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 4px);\n}\n.v-list-item--slim .v-list-item__prepend > .v-list-item-action ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 4px);\n}\n.v-list-item--three-line .v-list-item__prepend {\n  align-self: start;\n}\n\n.v-list-item__append {\n  align-self: center;\n  display: flex;\n  align-items: center;\n  grid-area: append;\n}\n.v-list-item__append .v-list-item__spacer {\n  order: -1;\n  transition: 150ms width cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-list-item__append * ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap);\n}\n.v-list-item__append > .v-badge ~ .v-list-item__spacer,\n.v-list-item__append > .v-icon ~ .v-list-item__spacer,\n.v-list-item__append > .v-tooltip ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 32px);\n}\n.v-list-item__append > .v-avatar ~ .v-list-item__spacer,\n.v-list-item__append > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 16px);\n}\n.v-list-item__append > .v-list-item-action ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 16px);\n}\n.v-list-item--slim .v-list-item__append > .v-badge ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__append > .v-icon ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__append > .v-tooltip ~ .v-list-item__spacer {\n  width: var(--v-list-slim-spacer-width, 20px);\n}\n.v-list-item--slim .v-list-item__append > .v-avatar ~ .v-list-item__spacer,\n.v-list-item--slim .v-list-item__append > .v-badge:is(:has(.v-avatar)) ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 4px);\n}\n.v-list-item--slim .v-list-item__append > .v-list-item-action ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 4px);\n}\n.v-list-item--three-line .v-list-item__append {\n  align-self: start;\n}\n\n.v-list-item__content {\n  align-self: center;\n  grid-area: content;\n  overflow: hidden;\n  min-width: 40px;\n}\n.v-navigation-drawer--rail:not(.v-navigation-drawer--expand-on-hover) .v-list-item__content, .v-navigation-drawer--rail.v-navigation-drawer--expand-on-hover:not(.v-navigation-drawer--is-hovering) .v-list-item__content {\n  min-width: 0;\n}\n\n.v-list-item-action {\n  align-self: center;\n  display: flex;\n  align-items: center;\n  flex: none;\n  transition: inherit;\n  transition-property: height, width;\n}\n.v-list-item-action--start {\n  margin-inline-end: 8px;\n  margin-inline-start: -8px;\n}\n.v-list-item-action--end {\n  margin-inline-start: 8px;\n  margin-inline-end: -8px;\n}\n\n.v-list-item-media {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.v-list-item-media--start {\n  margin-inline-end: 16px;\n}\n.v-list-item-media--end {\n  margin-inline-start: 16px;\n}\n.v-list-item--two-line .v-list-item-media {\n  margin-top: -4px;\n  margin-bottom: -4px;\n}\n.v-list-item--three-line .v-list-item-media {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.v-list-item-subtitle {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  opacity: var(--v-list-item-subtitle-opacity, var(--v-medium-emphasis-opacity));\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  overflow-wrap: break-word;\n  word-break: initial;\n}\n.v-list-item--one-line .v-list-item-subtitle {\n  -webkit-line-clamp: 1;\n}\n.v-list-item--two-line .v-list-item-subtitle {\n  -webkit-line-clamp: 2;\n}\n.v-list-item--three-line .v-list-item-subtitle {\n  -webkit-line-clamp: 3;\n}\n.v-list-item-subtitle {\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0.0178571429em;\n  line-height: 1rem;\n  text-transform: none;\n}\n.v-list-item--nav .v-list-item-subtitle {\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0.0178571429em;\n  line-height: 1rem;\n}\n\n.v-list-item-title {\n  hyphens: auto;\n  overflow-wrap: normal;\n  overflow: hidden;\n  padding: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-break: normal;\n  word-wrap: break-word;\n}\n.v-list-item-title {\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.009375em;\n  line-height: 1.5;\n  text-transform: none;\n}\n.v-list-item--nav .v-list-item-title {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  letter-spacing: normal;\n  line-height: 1rem;\n}\n\n.v-list-item--density-default {\n  min-height: 40px;\n}\n.v-list-item--density-default.v-list-item--one-line {\n  min-height: 48px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.v-list-item--density-default.v-list-item--two-line {\n  min-height: 64px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.v-list-item--density-default.v-list-item--three-line {\n  min-height: 88px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.v-list-item--density-default.v-list-item--three-line .v-list-item__prepend,\n.v-list-item--density-default.v-list-item--three-line .v-list-item__append {\n  padding-top: 8px;\n}\n.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-default:not(.v-list-item--nav).v-list-item--two-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-default:not(.v-list-item--nav).v-list-item--three-line {\n  padding-inline: 16px;\n}\n\n.v-list-item--density-comfortable {\n  min-height: 36px;\n}\n.v-list-item--density-comfortable.v-list-item--one-line {\n  min-height: 44px;\n}\n.v-list-item--density-comfortable.v-list-item--two-line {\n  min-height: 60px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.v-list-item--density-comfortable.v-list-item--three-line {\n  min-height: 84px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.v-list-item--density-comfortable.v-list-item--three-line .v-list-item__prepend,\n.v-list-item--density-comfortable.v-list-item--three-line .v-list-item__append {\n  padding-top: 6px;\n}\n.v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--one-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--two-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-comfortable:not(.v-list-item--nav).v-list-item--three-line {\n  padding-inline: 16px;\n}\n\n.v-list-item--density-compact {\n  min-height: 32px;\n}\n.v-list-item--density-compact.v-list-item--one-line {\n  min-height: 40px;\n}\n.v-list-item--density-compact.v-list-item--two-line {\n  min-height: 56px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.v-list-item--density-compact.v-list-item--three-line {\n  min-height: 80px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.v-list-item--density-compact.v-list-item--three-line .v-list-item__prepend,\n.v-list-item--density-compact.v-list-item--three-line .v-list-item__append {\n  padding-top: 4px;\n}\n.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--one-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--two-line {\n  padding-inline: 16px;\n}\n.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--three-line {\n  padding-inline: 16px;\n}\n\n.v-list-item--nav {\n  padding-inline: 8px;\n}\n\n.v-list-item__underlay {\n  position: absolute;\n}\n\n.v-list-item__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: 0.2s ease-in-out;\n  transition-property: opacity, color;\n}\n.v-list-item--active.v-list-item--variant-elevated .v-list-item__overlay {\n  --v-theme-overlay-multiplier: 0;\n}\n\n.v-list {\n  --indent-padding: 0px;\n}\n.v-list--nav {\n  --indent-padding: -8px;\n}\n\n.v-list-group {\n  --list-indent-size: 16px;\n  --parent-padding: var(--indent-padding);\n  --prepend-width: var(--v-list-group-prepend, 40px);\n}\n.v-list--slim .v-list-group {\n  --prepend-width: var(--v-list-group-prepend, 28px);\n}\n.v-list-group--fluid {\n  --list-indent-size: 0px;\n}\n.v-list-group--prepend {\n  --parent-padding: calc(var(--indent-padding) + var(--prepend-width));\n}\n.v-list-group--fluid.v-list-group--prepend {\n  --parent-padding: var(--indent-padding);\n}\n\n.v-list-group__items {\n  --indent-padding: calc(var(--parent-padding) + var(--v-list-indent, var(--list-indent-size)));\n  min-width: min-content;\n}\n.v-navigation-drawer--rail .v-list-group__items {\n  min-width: 0;\n}\n\n.v-list-group__items .v-list-item {\n  padding-inline-start: calc(16px + var(--indent-padding)) !important;\n}\n\n.v-list-group__header:not(.v-treeview-item--activatable-group-activator).v-list-item--active:not(:focus-visible) .v-list-item__overlay {\n  opacity: 0;\n}\n.v-list-group__header:not(.v-treeview-item--activatable-group-activator).v-list-item--active:hover .v-list-item__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n\n@media (forced-colors: active) {\n  .v-list-item--link:not(.v-list-item--active) {\n    color: buttontext;\n  }\n  .v-list-item--link[href]:not(.v-list-item--active) {\n    color: unset;\n  }\n  .v-list-item--active:not(.v-list-item--disabled) [class*=v-list-item-],\n  .v-list-item--active:not(.v-list-item--disabled) [class*=v-list-item-] > *,\n  .v-list-item--active:not(.v-list-item--disabled) .v-icon {\n    color: highlight !important;\n  }\n  .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) {\n    background: highlight !important;\n  }\n  .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) [class*=v-list-item-],\n  .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) [class*=v-list-item-] > *,\n  .v-list-item--active:not(.v-list-item--variant-text, .v-list-item--variant-plain):not(.v-list-item--disabled) .v-icon {\n    opacity: 1;\n    color: highlighttext !important;\n    forced-color-adjust: preserve-parent-color;\n  }\n  .v-list-item--focus-visible::after {\n    opacity: 1;\n  }\n  @supports selector(:focus-visible) {\n    .v-list-item::after {\n      color: buttontext;\n    }\n    .v-list-item:focus-visible::after {\n      opacity: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
